<template>
    <div class="wrapper">
        <side-bar>
            <template #links>
                <sidebar-link to="/app/" name="XSS Payload Fires" icon="fas fa-fire" />
                <sidebar-link to="/app/xsspayloads" name="XSS Payloads" icon="fas fa-file-code" />
                <sidebar-link to="/app/settings" name="Settings" icon="fas fa-cogs" />
                <li class="nav-item mt-5">
                  <a target="_blank" href="https://mtl-gitlab.mgcorp.co/p_surugiu" class="nav-link">
                    <i class="fab fa-twitter"></i>
                    <p>Petru Surugiu</p>
                  </a>
                </li>
                <li class="nav-item">
                  <a target="_blank" href="https://mtl-gitlab.mgcorp.co/mg/eng/corpit/infosec/appsec/mg-xsshunter/" class="nav-link">
                    <i class="fab fa-github"></i>
                    <p>Gitlab mg-xsshunter</p>
                  </a>
                </li>
            </template>
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>
            <dashboard-content @click="toggleSidebar">
            </dashboard-content>
            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
    components: {
        TopNavbar,
        ContentFooter,
        DashboardContent,
        MobileMenu
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
};
</script>
